/*

Ashraf        09/23/2022 2701323910 fixed validation messages in record format
Sohel         10/06/2022 2701323910 Record Format ->File Type and Record Format System Notes Payload Changes
Sohel         10/27/2022 2701323910 Record Format ->Added classnames and removed few styles for the text feilds as per the design
akhila        10/27/2022 2701323910  record format UX Changes
*/

import {
  Typography,
  Button,
  TextField,
  FormHelperText,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
} from '@material-ui/core';
import React, {useEffect, useState, useContext} from 'react';
import DialogBox from '../../../../components/DialogBox';
import * as Yup from 'yup';
import {
  postRecordFormat,
  ResetMessage as resetMessage,
  ResetStatus as resetStatus,
  resetRecordFormatData,
  ResetEnableAddRecord as resetEnableAddRecord,
  resetOverrideStatus,
} from '../../../../redux/reducers/BRE/AddRecordFormat';
import FieldSearch from './RecordFormatFieldSearch/index';
import {getFields} from './RecordFormatFieldSearch/RecordFormatFieldSearchTable';
import {Form, Formik} from 'formik';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import {ExpandMore} from '@material-ui/icons';
import {makeStyles} from '@material-ui/core/styles';
import RecordFormatSystemNotes from '../AddRecordFormat/RecordFormatSystemNotes';
import AppContext from '../../../../components/contextProvider/AppContextProvider/AppContext';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import FieldTable from './FieldTable';
import {useDispatch, useSelector} from 'react-redux';
import PageLoader from '../../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../components/CustomSnackBar';
import SearchFilterGroup from '../../../RecordFormat/SearchFilterGroup/index';
import {FILE_TYPE} from '../../../../constants/Lookup';
import {getOptions} from '../../../../util/GetDropDownOptions';
import OverrideRule from '../../../../components/OverrideRule';
import {ArrowBack} from '@material-ui/icons';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';
const useStyles = makeStyles((theme) => ({
  root: {
    'width': '100%',
    'margin': '10px 0 0',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '10px',
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
  },
  detailsCard: {
    padding: 10,
    borderRadius: '0px 0px 8px 8px',
    backgroundColor: '#fbfbfb',
  },
}));
const AddRecordFormat = ({
  setRecordFormatCode,
  recordFormatCode,
  setValue,
  setTabValue,
  setFormatType,
  isCopyIcon,
  setFieldListId,
  notesEnable,
  roleDataFormat,
}) => {
  const classes1 = useStyles();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [dialogState, setDialogState] = useState(false);
  const {reportMasterId} = useContext(AppContext);
  const [selectedRows, setSelectedRows] = useState([]);
  const [expanded, setExpanded] = React.useState();
  const [showSearchFilterGroup, setShowSearchFilterGroup] = useState(false);
  const [recordFormatFilterGroupCode, setRecordFormatFilterGroupCode] = useState(false);
  const [recordFormatFilterGroupId, setRecordFormatFilterGroupId] = useState('');
  const [overRiding, setOverRiding] = useState({});
  const [reset, setReset] = useState(false);

  const {
    isLoading,
    successMsg,
    errorMsg,
    addRecordFormatStatus,
    recordFormatData,
    dropDownData,
    addEnableRecordData,
    addEnableRecordStatus,
    userMetrix,
  } = useSelector(({addRecordFormat}) => addRecordFormat);

  const [deleteEnableId, setDeleteEnableId] = useState('');

  const handleAccordionChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  useEffect(() => {
    dispatch(resetStatus());
    setFieldListId(false);
  }, []);
  useEffect(() => () => dispatch(resetRecordFormatData()), []);
  const fieldSeperators = [
    {key: ',', value: ','},
    {key: '|', value: '|'},
    {key: '~', value: '~'},
  ];
  const handleCloseFilterSearch = () => {
    setShowSearchFilterGroup(false);
  };
  const handleDialogState = () => {
    setDialogState(false);
    dispatch(resetOverrideStatus());
  };
  const initialState = {
    code: '',
    description: '',
    fileType: '',
    fieldHeader: '',
    fixedLength: 'none',
    seperator: 'none',
    filterGroup: '',
  };

  const [inputFieldValues, setInputFieldValues] = useState(initialState);
  useEffect(() => {
    if (recordFormatData['members']?.length > 0) {
      const initialState = {
        code: recordFormatData.code || '',
        description: recordFormatData.description || '',
        fileType: recordFormatData?.type?.toUpperCase() || '',
        fixedLength:
          recordFormatData.fixedLength === 'yes' ?
            'Y' :
            recordFormatData.fixedLength === 'no' ?
              'N' :
              'none' || 'none',
        seperator: recordFormatData.seperator || 'none',
        filterGroup: recordFormatData.filterGroup || '',
      };
      setRecordFormatFilterGroupCode(recordFormatData?.filterGroup || '');
      recordFormatData['members']?.forEach((r) => {
        initialState['fieldLength' + r.fieldCode] = r.fieldLength || '';
        initialState['fieldHeader' + r.fieldCode] = r.fieldHeader;
        initialState['format' + r.fieldCode] = r.format || '';
        initialState['printTotals' + r.fieldCode] = r.printTotals || 'none';
        initialState['printTotals' + r.fieldCode] = r.printTotals || 'none';
        initialState['seqNo' + r.fieldCode] = r.sequence || '';
      });
      setInputFieldValues(initialState);
      const selectedMembers = recordFormatData['members']?.map((member) => {
        return {
          ...member,
          ...getFields(member),
          tableData: {checked: true, id: member.fieldCode},
        };
      });

      setSelectedRows(selectedMembers);
    } else {
      setInputFieldValues(initialState);
      setSelectedRows([]);
    }
  }, [recordFormatData, reset]);
  const validationSchema = Yup.object().shape({
    code: Yup.string()
      .required('Record format code is required')
      .matches(
        /^[a-zA-Z0-9]+$/,
        'Record Format Code cannot contain white space/special characters',
      ),
    fixedLength: Yup.string()
      .notOneOf(['none'], 'Fixed length is required')
      .required('Fixed length is required'),
    seperator: Yup.string().when('fixedLength', {
      is: (val) => val === 'N',
      then: Yup.string()
        .notOneOf(['none'], 'Seperator is required')
        .required('Separator is required'),
    }),
  });
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (addRecordFormatStatus === 200) {
      setFormatType('Enable');
      setTimeout(() => {
        dispatch(resetMessage());
        setValue(0);
      }, 2000);
      const initialState = {
        code: '',
        description: '',
        fileType: '',
        fixedLength: 'none',
        fieldHeader: '',
        seperator: '',
        filterGroup: '',
      };
      setRecordFormatFilterGroupCode('');
      setInputFieldValues(initialState);
      setSelectedRows([]);
      dispatch(resetStatus());
      if (reportMasterId !== '') {
        setTabValue(2);
      }
    }
  }, [addRecordFormatStatus]);
  useEffect(() => {
    if (addEnableRecordStatus === 200 && userMetrix === 'Yes') {
      setDialogState(true);
      setTimeout(() => {
        dispatch(resetEnableAddRecord());
      }, 2500);
    }
  }, [userMetrix, addEnableRecordStatus]);
  const initialVal = {
    code: isCopyIcon ? '' : inputFieldValues.code,
    description: inputFieldValues.description,
    fileType: inputFieldValues.fileType,
    fixedLength: inputFieldValues.fixedLength,
    fieldHeader: inputFieldValues.fieldHeader,
    seperator: inputFieldValues.seperator,
    filterGroup: inputFieldValues.filterGroup,
  };
  selectedRows?.forEach((r, i) => {
    initialVal['fieldLength' + r.fieldCode] = inputFieldValues['fieldLength' + r.fieldCode];
    initialVal['format' + r.fieldCode] = inputFieldValues['format' + r.fieldCode];
    initialVal['seqNo' + r.fieldCode] = inputFieldValues['seqNo' + r.fieldCode];
    if (
      inputFieldValues['fieldHeader' + r.fieldCode] !== null &&
      inputFieldValues['fieldHeader' + r.fieldCode] !== ''
    ) {
      initialVal['fieldHeader' + r.fieldCode] =
        inputFieldValues['fieldHeader' + r.fieldCode] || r.description;
    }
    initialVal['printTotals' + r.fieldCode] = inputFieldValues['printTotals' + r.fieldCode];
  });

  const onSubmit = (data, {resetForm}) => {
    const fieldsList = selectedRows.map((r, i) => {
      const field = {};
      field['fieldCode'] = r.fieldCode;
      if (data['fieldLength' + r.fieldCode]) {
        field['fieldLength'] = data['fieldLength' + r.fieldCode];
      }
      field['sequence'] = Number(data['seqNo' + r.fieldCode]);
      field['format'] = data['format' + r.fieldCode];
      field['fieldHeader'] = data['fieldHeader' + r.fieldCode];
      field['memberId'] = !isCopyIcon ? r.memberId : undefined;
      field['fieldType'] = r?.fieldType?.toUpperCase();
      field['dataType'] = r.dataType ? r.dataType : '';
      field['description'] = r.description;
      return field;
    });
    const passValues = {
      code: data.code.toUpperCase(),
      deletedId: deleteEnableId ? deleteEnableId : [],
      description: data.description,
      members: fieldsList,
      fixedLength: data.fixedLength === 'Y' ? 'yes' : 'no',
      seperator: data.seperator || '',
      type: data?.fileType?.value ? data?.fileType?.value : data?.fileType,
      recordFormatId: (!isCopyIcon && recordFormatData['recordFormatId']) || '0',
      filtergroupid: recordFormatFilterGroupId ?
        recordFormatFilterGroupId :
        recordFormatData?.filterGroupId ?
          recordFormatData?.filterGroupId :
          0,
      frameWorkType: 'Enable',
      filterGroup: recordFormatFilterGroupCode ? recordFormatFilterGroupCode : data.filterGroup,
      override: 'No',
    };
    setOverRiding(passValues);
    dispatch(postRecordFormat(passValues));
  };
  return (
    <>
      <Formik
        onSubmit={(values, props) => onSubmit(values, props)}
        initialValues={initialVal}
        validationSchema={validationSchema}
        enableReinitialize
        validateOnChange={false}
      >
        {(props) => {
          const {values, handleChange, setFieldValue, touched, errors, resetForm} = props;

          return (
            <div className={`${classes.tabCardStyles} mb-0`}>
              <div className="button-table-spacing-mb justify-content-start">
                <Button
                  variant="outlined"
                  type="button"
                  className={`search-btn mx-1`}
                  onClick={() => {
                    setValue(0);
                  }}
                >
                  <ArrowBack className="mr-2" />
                    Search Record Format
                </Button>
              </div>
              <Form noValidate>
                <div className="form-row global-field-textfields">
                  <div className="col-sm-6 col-md-4 col-xl-4 form-group">
                    <TextField
                      className={` ${classes.labelName} ${classes.inputLabel}`}
                      placeholder="Enter Record Format Code"
                      margin="dense"
                      name="code"
                      variant="outlined"
                      value={values?.code?.toUpperCase()}
                      onChange={(e) => {
                        setFieldValue('code', e.target.value);
                        setInputFieldValues({...inputFieldValues, code: e.target.value});
                      }}
                      label={`Record Format Code`}
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                      error={errors.code}
                    />
                    <FormHelperText style={{color: 'red'}} variant="outlined">
                      {errors && errors.code}
                    </FormHelperText>
                  </div>
                  <div className="col-sm-6 col-md-4 col-xl-4 form-group">
                    <TextField
                      className={` ${classes.labelName} ${classes.inputLabel}`}
                      placeholder="Enter Record Format Description"
                      margin="dense"
                      name="description"
                      variant="outlined"
                      value={values.description}
                      onChange={(e) => {
                        setFieldValue('description', e.target.value);
                        setInputFieldValues({...inputFieldValues, description: e.target.value});
                      }}
                      label="Record Format Description"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                      error={errors.description}
                    />
                    <FormHelperText variant="outlined">
                      {errors && errors.description}
                    </FormHelperText>
                  </div>
                  <div
                    className={`col-sm-6 col-md-4 col-xl-4 form-group ${classes.selectdropdown}`}
                  >
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="fileType"
                      id="fileType"
                      size="small"
                      value={values.fileType}
                      options={getOptions(FILE_TYPE, dropDownData)}
                      getOptionDisabled={(option) => option.valueCode === null}
                      getOptionLabel={(option) => {
                        return option?.value ?
                          option?.value :
                          option?.value === undefined ?
                            option :
                            option.value;
                      }}
                      required
                      onChange={(e, value) => {
                        handleChange(e);
                        setInputFieldValues({...inputFieldValues, fileType: value});
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={` ${classes.labelName} ${classes.selectLabel}`}
                            {...params}
                            variant="outlined"
                            margin="dense"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            label="File Type"
                            placeholder="Select File Type"
                          />
                        </div>
                      )}
                    />
                  </div>
                  <div
                    className={`col-sm-6 col-md-4 col-xl-4 form-group ${classes.selectdropdown}`}
                  >
                    <FormControl margin="dense" variant="outlined" fullWidth>
                      <InputLabel error={errors.fixedLength} required>
                        Fixed Length
                      </InputLabel>
                      <Select
                        fullWidth
                        name="type"
                        className="select-gender"
                        error={errors.fixedLength}
                        value={values.fixedLength}
                        onChange={(e) => {
                          setFieldValue('fixedLength', e.target.value);
                          setInputFieldValues({...inputFieldValues, fixedLength: e.target.value});
                        }}
                        label="Fixed Length"
                      >
                        <MenuItem value="none" key="none" disabled>
                          <span className="defaultSelected">Select Fixed Length</span>
                        </MenuItem>
                        <MenuItem value={'Y'} key={'Y'}>
                          Yes
                        </MenuItem>
                        <MenuItem value={'N'} key={'N'}>
                          No
                        </MenuItem>
                      </Select>
                    </FormControl>
                    <FormHelperText>
                      {touched.fixedLength && errors.fixedLength && errors.fixedLength}
                    </FormHelperText>
                  </div>
                  <div
                    className={`col-sm-6 col-md-4 col-xl-4 form-group ${classes.selectdropdown}`}
                  >
                    <FormControl
                      required={values.fixedLength === 'N'}
                      margin="dense"
                      variant="outlined"
                      fullWidth
                    >
                      <InputLabel>Separator</InputLabel>
                      <Select
                        fullWidth
                        name="type"
                        value={values.seperator}
                        onChange={(e) => {
                          setFieldValue('seperator', e.target.value);
                          setInputFieldValues({...inputFieldValues, seperator: e.target.value});
                        }}
                        label="Separator"
                      >
                        <MenuItem value="none" key="none" disabled>
                          <span className="defaultSelected">Select Seperator</span>
                        </MenuItem>
                        {fieldSeperators.map((sep) => (
                          <MenuItem value={sep.value} key={sep.key}>
                            {sep.value}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormHelperText>
                      {touched.seperator && errors.seperator && errors.seperator}
                    </FormHelperText>
                  </div>
                  <div className="col-sm-6 col-md-4 col-xl-4 form-group">
                    <TextField
                      className={` ${classes.labelName} ${classes.inputLabel}`}
                      placeholder="Enter Filter Group"
                      margin="dense"
                      name="filterGroup"
                      variant="outlined"
                      value={
                        recordFormatFilterGroupCode ?
                          recordFormatFilterGroupCode :
                          values.filterGroup
                      }
                      onChange={(e) => {
                        setFieldValue('filterGroup', e.target.value);
                        setInputFieldValues({...inputFieldValues, filterGroup: e.target.value});
                      }}
                      InputProps={{
                        endAdornment: (
                          <Button
                            variant="contained"
                            className={` ${classes.filterGroupButton}`}
                            onClick={() => setShowSearchFilterGroup(true)}
                          >
                            Search
                          </Button>
                        ),
                      }}
                      label="Filter Group"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                    />
                  </div>
                </div>
                <div>
                  <DialogBox
                    open={showSearchFilterGroup}
                    dialogClose={() => handleCloseFilterSearch()}
                    title="Add Filter Group"
                    maxWidth="lg"
                  >
                    <SearchFilterGroup
                      handleClose={handleCloseFilterSearch}
                      setRecordFormatFilterGroupCode={setRecordFormatFilterGroupCode}
                      setRecordFormatFilterGroupId={setRecordFormatFilterGroupId}
                    />
                  </DialogBox>
                </div>
                <div className={` ${classes.cardBordernoneStyles} mb-0 border-rounded`}>
                  <div className="table-header">
                    <Typography variant="h4" className={classes.heading}>
                      Fields
                    </Typography>
                    <Button
                      variant="outlined"
                      className={`search-btn`}
                      onClick={() => setOpen(true)}
                    >
                      Map Variables
                    </Button>
                  </div>

                  <FieldTable
                    errors={errors}
                    touched={touched}
                    values={values}
                    setSelectedRows={setSelectedRows}
                    selectedRows={selectedRows}
                    setFieldValue={setFieldValue}
                    inputFieldValues={inputFieldValues}
                    setInputFieldValues={setInputFieldValues}
                    handleChange={handleChange}
                    setDeleteEnableId={setDeleteEnableId}
                    deleteEnableId={deleteEnableId}
                    recordFormatCode={recordFormatCode}
                  />
                </div>
                <div className="row justify-content-center my-3">
                  <Button
                    type="button"
                    variant="outlined"
                    className={`search-btn mx-1 ${classes.buttonRoot}`}
                    onClick={() => {
                      if (!recordFormatCode) {
                        setInputFieldValues(initialState);
                        setRecordFormatFilterGroupCode('');
                        resetForm(initialVal);
                        setSelectedRows([]);
                      } else {
                        setReset(!reset);
                      }
                    }}
                  >
                    Cancel
                  </Button>
                  {(Object.keys(recordFormatData).length > 0 ?
                    roleDataFormat?.edit :
                    roleDataFormat?.add) &&
                  selectedRows &&
                  selectedRows.length > 0 ? (
                      <Button
                        type="submit"
                        variant="outlined"
                        className={`search-btn mx-1 ${classes.buttonRoot}`}
                        color="primary"
                      >
                      Save
                      </Button>
                    ) : (
                      <Tooltip title="Please add atleast one field to continue">
                        <span>
                          <Button
                            type="submit"
                            variant="outlined"
                            className={`search-btn mx-1 ${classes.buttonRoot}`}
                            color="primary"
                            disabled
                          >
                          Save
                          </Button>
                        </span>
                      </Tooltip>
                    )}
                </div>
                <DialogBox
                  open={open}
                  dialogClose={handleClose}
                  title="Map Variables"
                  maxWidth="lg"
                >
                  <FieldSearch
                    setSearchData={setSearchData}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    handleClose={handleClose}
                    inputFieldValues={inputFieldValues}
                    setInputFieldValues={setInputFieldValues}
                    searchData={searchData}
                  />
                </DialogBox>
              </Form>
              <OverrideRule
                dialogTitle="Override Enable Record Format"
                dialogOpen={dialogState}
                dialogClose={handleDialogState}
                title="This Enable Record Format has been used in the following frameworks."
                data={addEnableRecordData}
                handleOverrideClose={handleDialogState}
                handleOverrideSubmit={() => {
                  dispatch(postRecordFormat({...overRiding, override: 'Yes'}));
                  handleDialogState();
                }}
              />
              {recordFormatData?.recordFormatId &&
                recordFormatData?.frameWorkType === 'Enable' &&
                !isCopyIcon && (
                <div className={classes1.root}>
                  <Accordion
                    elevation={0}
                    className="accordion-styling"
                    expanded={expanded === 'panel1'}
                    onChange={handleAccordionChange('panel1')}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMore />}
                      aria-controls="panel1d-content"
                      id="panel1d-header"
                    >
                      <Typography className={classes1.heading}>
                          Enable Record Format Notes
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes1.detailsCard}>
                      <Typography>
                        <RecordFormatSystemNotes
                          setRecordFormatCode={setRecordFormatCode}
                          recordFormatCode={recordFormatCode}
                        />
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                </div>
              )}
            </div>
          );
        }}
      </Formik>
      {isLoading && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default AddRecordFormat;
